import {
    CLEAR_FILTER,
    PARENT_FILTERS_CHANGED, RESET_ALL_FILTERS,
    RETURN_AIRPORT_SELECTED, RETURN_AIRPORTS_BATCH_RECEIVED,
    SET_SELECTED_URL_FILTERS
} from "../../actions/FlightsActions";

const initialState = {
    airports: {},
    selected: []
};

const ReturnAirportsFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case RETURN_AIRPORTS_BATCH_RECEIVED:
            return {
                ...state, airports: action.payload
            };
        case RETURN_AIRPORT_SELECTED:
            if (state.selected.indexOf(action.airport) === -1) {
                return {
                    ...state, selected: [...state.selected, action.airport]
                };
            }

            return {
                ...state, selected: state.selected.filter(item => item !== action.airport)
            };
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'returnAirports') {
                return {
                    ...state,
                    selected: action.payload,
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            return {...state,
                selected: action.filters.returnAirports,
            };
        case CLEAR_FILTER:
            if (action.filter === 'returnAirports') {
                return {...state, selected: initialState.selected};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, selected: initialState.selected};
        default:
            return state
    }
};

export default ReturnAirportsFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/ReturnAirportsFilterReducer.js